import type { TenantOverview } from '@isg/shared-types';
import { tenantOverviewSchema } from '@isg/validation';

/**
 * GET /api/tenant sonucu. 403 bir "hata" değil, anlamlı bir sonuçtur
 * (eşlenmemiş/pasif kullanıcı) ve mesajı ekranda ayırt edici gösterilir —
 * bu yüzden throw edilmez, ayrı kolda döner.
 */
export type TenantResult =
  { kind: 'ok'; tenant: TenantOverview } | { kind: 'forbidden'; message: string };

export async function fetchTenant(
  accessToken: string,
  signal?: AbortSignal,
): Promise<TenantResult> {
  const response = await fetch('/api/tenant', {
    headers: { Authorization: `Bearer ${accessToken}` },
    signal,
  });
  if (response.status === 403) {
    const body = (await response.json().catch(() => null)) as { message?: string } | null;
    return { kind: 'forbidden', message: body?.message ?? 'Erişim reddedildi' };
  }
  if (!response.ok) {
    throw new Error(`API ${response.status} döndü`);
  }
  return { kind: 'ok', tenant: tenantOverviewSchema.parse(await response.json()) };
}
